import * as React from "react";

/**
 * Mobile bottom sheet with grip. Renders inside the nearest positioned ancestor (the phone frame / viewport container).
 */
export interface BottomSheetProps {
  open?: boolean;
  onClose?: () => void;
  children: React.ReactNode;
}

export function BottomSheet({ open = true, onClose, children }: BottomSheetProps): JSX.Element | null {
  if (!open) return null;
  return (
    <>
      <div className="gk-sheet-scrim" onClick={onClose} />
      <div className="gk-sheet" role="dialog" aria-modal="true">
        <div className="gk-sheet__grip" />
        {children}
      </div>
    </>
  );
}
